import {
  getGsiteValueFromUrl,
  getVfValueFromUrl
} from '../../offer/business/privateDeals'
export const GSITE_RATE_CHECKER_IDENTIFIER = 'verification'

/**
 * Checks if the rate checker param gsite=verification is present in the URL
 * @param searchParams - The search params object
 * @returns Whether the rate checker param is present in the URL
 */
export const isRateCheckerFromUrl = <T extends Record<string, unknown>>(
  searchParams: T
) => {
  const gsiteParam = getGsiteValueFromUrl(searchParams)
  return gsiteParam === GSITE_RATE_CHECKER_IDENTIFIER
}

/**
 * Checks if the hotel ads verifier param vf=true is present in the URL
 * @param searchParams - The search params object
 * @returns Whether the hotel ads verifier param is present in the URL
 */
export const isHotelAdsVerifierFromUrl = <T extends Record<string, unknown>>(
  searchParams: T
) => {
  const vfParam = getVfValueFromUrl(searchParams)
  return vfParam === 'true' || vfParam === '1'
}
